import React, { useEffect, useState } from "react"
import { MagicCheckboxProps } from "../types"
import AdditionalInfo from "./AdditionalInfo"
import { fi } from 'date-fns/locale'
import { BetaTag, NewTag } from 'components/navbar/Navbar'

const MagicCheckbox = ({name, setMagicData, fieldKey, disabled, additionalInfoText } : MagicCheckboxProps) => {
  const MagicCheckboxUnchecked = ['generateAiAudio', 'generateAiVideo']
  const [isChecked, setIsChecked] = useState(!MagicCheckboxUnchecked.includes(fieldKey))

  useEffect(() => {
    setMagicData((prevData) => ({
      ...prevData,
      [fieldKey]: isChecked,
    }))
  }, [isChecked])

  const handleChange = (event) => {
    setIsChecked(event.target.checked)
  }

  return (
    <div className="flex flex-row space-x-2 position-relative" style={{position: 'relative'}}>
      <label>
        <input
          type="checkbox"
          className="focus:ring-magic h-4 w-4 text-magic border-magic rounded mr-2"
          checked={isChecked}
          onChange={handleChange}
          disabled={disabled}
        />
        {name}
      </label>
      {additionalInfoText && <AdditionalInfo tooltipContent={<div>{additionalInfoText}</div>} interactive />}
      {fieldKey === 'generateAiAudio' &&<BetaTag y='top-0' x='right-2'/>}
    </div>
  )
}

export default MagicCheckbox